import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../assets/stylesheets/Countdown.scss';
import Game2Store from "../stores/Game2Store";

export default class Countdown extends Component {

    constructor(props) {
        super(props);

        this.interval = null;

        this.state = {
            ready: props.ready,
            seconds: props.seconds,
            minutes: props.minutes
        }
    }

    static propTypes = {
        ready: PropTypes.bool,
        seconds: PropTypes.number,
        minutes: PropTypes.number
    };

    static defaultProps = {
        ready: true,
        seconds: 30,
        minutes: 2
    };

    componentWillReceiveProps(nextProps) {
        clearInterval(this.interval);
        this.setState({...nextProps});
    }

    startTimer = () => {
        this.setState({seconds: this.state.seconds - 1, ready: false})
        this.interval = setInterval(() => {

            if(  this.state.seconds <= 0 && this.state.minutes <= 0) {
                clearInterval(this.interval);
                this.props.onEndTimer({ready: true});
            } else if ( this.state.seconds <= 0 ) {
                this.setState({minutes: this.state.minutes - 1 ,seconds: 59, ready: false});
            } else {
                this.setState({seconds: this.state.seconds - 1, ready: false})
            }

        }, 1000);
    };

    resetTimer = () => {
        this.setState({minutes: this.props.minutes , seconds: this.props.seconds, ready: this.props.ready});
    };

    pauseTimer = () => {
        if( this.interval ) {
            clearInterval(this.interval);

            this.interval = setInterval(() => {
                this.setState({ready: false});
            }, 1000);
        }
    }

    resumeTimer() {
        this.interval = setInterval(() => {

            if(  this.state.seconds <= 0 && this.state.minutes <= 0) {
                clearInterval(this.interval);
            } else if ( this.state.seconds <= 0 ) {
                this.setState({minutes: this.state.minutes - 1 ,seconds: 59, ready: false});
            } else {
                this.setState({seconds: this.state.seconds - 1, ready: false})
            }

        }, 1000);
    }

    render() {

        if( Game2Store.pause ) {
            if (  this.state.seconds <= 0 && this.state.minutes <= 0) {
                Game2Store.start = false;
                Game2Store.pause = false;
            } else if (this.state.ready) {
                Game2Store.start = false;
                Game2Store.pause = false;
            } else {
                this.pauseTimer();
            }
        }

        if( Game2Store.start ) {
            if (  this.state.seconds <= 0 && this.state.minutes <= 0) {
                Game2Store.start = false;
                Game2Store.pause = false;
            } else if (this.state.ready) {
                Game2Store.start = false;
                Game2Store.pause = false;
            } else {
                clearInterval(this.interval);
                this.resumeTimer();
            }
        }

        if ( this.state.ready) {
            return (
                <div>
                    <button className="timer" onClick={this.startTimer}>{this.props.label || 'Timer'}</button>
                </div>
            );
        } else if (  this.state.seconds <= 0 && this.state.minutes <= 0) {
            return (
                <div>
                    <button className="timer" onClick={this.resetTimer}>{this.props.labelRestart || "Restart"}</button>
                </div>
            );
        } else {
            return (
                <div>
                    <button className="timer" >{this.state.minutes} : {this.state.seconds < 10 ? "0"+this.state.seconds : this.state.seconds}</button>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Countdown.js